export var ChartSchemaType = ['COMBINATION', 'LINE', 'BAR', 'PIE', 'TABLE', 'SINGLE_VALUE'];
export var CustomFormulaTypes = {
    sum: {
        type: 'sum',
        name: 'Sum',
        denominator: false,
    },
    average: {
        type: 'average',
        name: 'Average',
        denominator: false,
    },
    count: {
        type: 'count',
        name: 'Count',
        denominator: false,
    },
    countDistinct: {
        type: 'count_distinct',
        name: 'Count Distinct',
        denominator: false,
    },
    weightedAvg: {
        type: 'weighted_average',
        name: 'Weighted Average',
        denominator: true,
    },
    cumulative: {
        type: 'cumulative_total',
        name: 'Cumulative',
        denominator: false,
    },
};
var ChartSchema = /** @class */ (function () {
    function ChartSchema(_a) {
        var type = _a.type, dimensions = _a.dimensions, measures = _a.measures, breakdowns = _a.breakdowns;
        this.type = type;
        this.dimensions = dimensions;
        this.measures = measures;
        this.breakdowns = breakdowns;
    }
    ChartSchema.fromJSON = function (json) {
        var _a = Object.assign({}, json), type = _a.type, dimensions = _a.dimensions, measures = _a.measures, breakdowns = _a.breakdowns;
        if (typeof type !== 'string' && !ChartSchemaType.includes(type))
            throw new Error('type must be a string and include in ChartSchemaType');
        return new ChartSchema({
            type: type,
            dimensions: dimensions,
            measures: measures,
            breakdowns: breakdowns,
        });
    };
    return ChartSchema;
}());
export var LiftChartSchema = new ChartSchema({
    type: 'COMBINATION',
    dimensions: {
        required: ['X axis'],
        expansive: false,
    },
    measures: {
        required: ['Line', 'Bar'],
        expansive: false,
    },
    breakdowns: {
        required: null,
        expansive: true,
    },
});
export var LineChartSchema = new ChartSchema({
    type: 'LINE',
    dimensions: {
        required: ['X axis'],
        expansive: false,
    },
    measures: {
        required: ['Line'],
        expansive: false,
    },
    breakdowns: {
        required: null,
        expansive: true,
    },
});
export var BarChartSchema = new ChartSchema({
    type: 'BAR',
    dimensions: {
        required: ['X axis'],
        expansive: false,
    },
    measures: {
        required: ['Bar'],
        expansive: false,
    },
    breakdowns: {
        required: null,
        expansive: true,
    },
});
export var PieChartSchema = new ChartSchema({
    type: 'PIE',
    dimensions: {
        required: ['X axis'],
        expansive: false,
    },
    measures: {
        required: ['Pie'],
        expansive: false,
    },
    breakdowns: {
        required: null,
        expansive: true,
    },
});
export var TableChartSchema = new ChartSchema({
    type: 'TABLE',
    dimensions: {
        required: null,
        expansive: true,
    },
    measures: {
        required: null,
        expansive: true,
    },
    breakdowns: {
        required: null,
        expansive: false,
    },
});
export var SingleValueSchema = new ChartSchema({
    type: 'SINGLE_VALUE',
    dimensions: {
        required: ['Value'],
        expansive: true,
    },
    measures: {
        required: null,
        expansive: false,
    },
    breakdowns: {
        required: null,
        expansive: false,
    },
});
export default ChartSchema;
